var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","id":"infoTooltip"},on:{"click":_vm.showDialog}},[_c('vs-icon',{staticClass:"m-0 p-0",staticStyle:{"cursor":"pointer"},attrs:{"color":_vm.color,"size":"15px","icon":"info"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }